import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shopping-cart",
  "use": "icon-shopping-cart-usage",
  "viewBox": "0 0 20 19",
  "content": "<symbol viewBox=\"0 0 20 19\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shopping-cart\"><path d=\"M17.083 14.766v-1.341H5.613l.733-1.34 11.226-1.104 1.955-7.323H4.517L3.657 0H0v1.222h2.688l2.56 10.249-1.59 3.176v1.829c0 .976.859 1.829 1.836 1.829.97 0 1.83-.853 1.83-1.83 0-.977-.86-1.828-1.83-1.828h9.153v1.829c0 .976.851 1.829 1.829 1.829.976 0 1.829-.853 1.829-1.83 0-.858-.488-1.465-1.222-1.71\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol